import React from "react";
import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import SideNav from '../../shared/Sidenav';
import '../../../css/systemConfig/MaintainLookup.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import add from '../../../assets/images/add.svg';
import addDisable from '../../../assets/images/plus_disable.svg';
import calendar from '../../../assets/images/calendar.svg';
import Calendar from 'react-calendar';
import viewAccess from '../../../assets/images/viewOnlyAccess.svg';
import SuccessModal from '../../shared/SuccessModal';
import message from '../../../data/Message.json';
import TitleDescription from '../../../data/TitleDescription.json';
import MetaDecorator from '../../../ReactHelmet/MetaDecorator';
import { ApiCall } from '../../../Services/utils/ApiCall';
import { baseURL } from '../../../Services/config/apiGateway';
import { GETLOOKUPDATA_ENDPOINT, ADDLOOKUPDATA_ENDPOINT, UPDATELOOKUPDATA_ENDPOINT } from '../../../Services/config/apiEndPoints';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
toast.configure()
let viewOnly = false;
class MaintainLookup extends React.Component {
    constructor(props) {
        super(props)
        this.container = React.createRef();
        this.state = {
            isEdit: [],
            showFromCalendar: false,
            showToCalendar: false,
            showEffectiveCalendarArray: [false],
            showExpiryCalendarArray: [false],
            hasAddRow: false,
            editIndex: [],
            search: "",
            searchlength: 0,
            filteredIndex: [],
            confirmedHasOpen: false,
            maintainLookupData: [],
            lookupCode: '',
            lookupType: '',
            meaning: '',
            toCalendar: '',
            fromCalendar: '',
        }
        this.handlechange = this.handlechange.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }
    handleClickOutside = event => {
        if (this.container.current && !this.container.current.contains(event.target)) {
            this.setState({ showFromCalendar: false });
            this.setState({ showToCalendar: false });
            this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
            for (let index = 0; index < this.state.editIndex.length; index++) {
                const element = this.state.editIndex[index];
                let showEffectiveCalendarArray = this.state.showEffectiveCalendarArray;
                showEffectiveCalendarArray[element] = false;
                this.setState({ showEffectiveCalendarArray: showEffectiveCalendarArray })
                let showExpiryCalendarArray = this.state.showExpiryCalendarArray;
                showExpiryCalendarArray[element] = false;
                this.setState({ showExpiryCalendarArray: showExpiryCalendarArray })
            }
        }
    };
    getDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let d = new Date(Number(timeStamp));
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        this.setState({ fromMonth: d.getMonth() })
        return `${day}-${month}-${year}`;
    }
    onAddHandleLookup = () => {
        this.setState({ hasAddRow: true });
        document.getElementById('lookupData').scrollTop = 0;
        document.documentElement.scrollTop = 0;
    }
    toggleEffectiveCalendar = () => {
        this.setState({ showFromCalendar: !this.state.showFromCalendar })
    }
    handleFromDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ fromCalendar: formatted_date, showFromCalendar: false })
    }
    toggleExpiryCalendar = () => {
        this.setState({ showToCalendar: !this.state.showToCalendar });
    }
    handleToDateChanged = (e) => {
        const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
        let formatted_date = e.getDate() + "-" + months[e.getMonth()] + "-" + e.getFullYear();
        if (e.getDate() <= 9) {
            formatted_date = "0" + formatted_date;
        }
        this.setState({ toCalendar: formatted_date, showToCalendar: false })
    }
    handlechange = (e) => {
        this.setState({
            search: e.target.value,
        }
        );
        this.onSearch();
    };
    getDate = (timeStamp) => {
        let date = new Date(Number(timeStamp)).toString();
        let day = date.split(' ')[2];
        let month = date.split(' ')[1];
        let year = date.split(' ')[3];
        return `${day}-${month}-${year}`;
    }
    componentDidMount = () => {
        document.addEventListener("mousedown", this.handleClickOutside);
        var selectedTiles = [];
        let roleData = this.props.data;
        const roleDataLength = roleData.length;
        for (let z = 0; z < roleDataLength; z++) {
            var rd = roleData[z].permissions;
            selectedTiles.push(rd)
        }
        selectedTiles.map(x =>
            x.map(md => {
                if (md.functionId == 1) {
                    if (md.method.includes("View & Edit")) {
                        viewOnly = true
                    }
                }
            }))
        ApiCall(
            'GET',
            baseURL + GETLOOKUPDATA_ENDPOINT,
            {},
            {
                'Accept': 'application/json',
                'Content-Type': 'application/json',
                'x-cc-trace-id': '1234',
            }
        ).then(data => {
            if (data.flag !== -1) {
                if (data.flag === 500) {
                    toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                }
                else {
                    console.log('I am 200!');
                    console.log(data)
                    this.setState({ maintainLookupData: data, filteredIndex: data.map((x, i) => i) }, () => { console.log(this.state.maintainLookupData) })
                }
            }
            else {
                // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})
            }
        })
    }
    onConfirmMaintainLookup = () => {
        let fromTimeStamp = (new Date(this.state.fromCalendar)).toString().substring(4, 15);
        let toTimeStamp = (new Date(this.state.toCalendar)).toString().substring(4, 15);
        console.log("toDate", Date.parse(toTimeStamp).toString(), isNaN(this.state.toCalendar))
        let editedLookup = [];
        if (this.state.isEdit.length > 0) {
            if (this.handleEditValidation()) {
                this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
                for (let index = 0; index < this.state.editIndex.length; index++) {
                    const element = this.state.editIndex[index];
                    if (this.state.isEdit[element] == true) {
                        editedLookup.push(this.state.maintainLookupData[element])
                    }
                }
                ApiCall(
                    'PUT',
                    baseURL + UPDATELOOKUPDATA_ENDPOINT,
                    editedLookup,
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                    }
                ).then(apiData => {
                    if (apiData.flag !== -1) {
                        if (apiData.flag === 500) {
                            if (apiData.data.message.includes("duplicate")) {
                                toast(message.alert.lookupVarifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                    }
                })
            }
        }
        else {
            if (this.handleValidation()) {

                ApiCall(
                    'POST',
                    baseURL + ADDLOOKUPDATA_ENDPOINT,
                    {
                        "fromDate": Date.parse(fromTimeStamp).toString(),
                        "lookupCode": this.state.lookupCode,
                        "lookupType": this.state.lookupType,
                        "meaning": this.state.meaning,
                        "toDate": isNaN(this.state.toCalendar) ? Date.parse(toTimeStamp).toString() : 0
                    },
                    {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json',
                        'x-cc-trace-id': '1234',
                        'Access-Control-Allow-Origin': '*'
                    },
                ).then(data => {
                    if (data.flag !== -1) {
                        if (data.flag === 500) {
                            if (data.data.message.includes("duplicate")) {
                                toast(message.alert.lookupVarifed, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                            else {
                                toast(message.alert.failure, { position: toast.POSITION.TOP_CENTER, style: { color: "red" } })
                            }
                        }
                        else {
                            console.log('I am 200!');
                            this.setState({ confirmedHasOpen: true });
                        }
                    }
                    else {
                        // toast(message.alert.failure,{position:toast.POSITION.TOP_CENTER,style: {color:"red"}})

                    }
                })
            }
        }
    }
    onCloseConfirmed = () => {
        this.setState({ confirmedHasOpen: false });
        window.location.reload();
    }
    handlechangeLookupType = (e) => {
        this.setState({ lookupType: e.target.value })
    }
    handlechangeLookupCode = (e) => {
        this.setState({ lookupCode: e.target.value })
    }
    handlechangeMeaning = (e) => {
        this.setState({ meaning: e.target.value })
    }
    validateFormFields = () => {
        return this.state.lookupCode.length > 0 &&
            this.state.lookupType.length > 0 && this.state.fromCalendar.length > 0
    };

    validateEditFormFields = () => {
        let validEdit = [];
        this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < this.state.editIndex.length; index++) {
            const element = this.state.editIndex[index];
            if (this.state.isEdit[element]) {
                validEdit = validEdit.concat(this.state.maintainLookupData[element].lookupCode.length > 0)
            }
        }
        return !validEdit.includes(false)
    };
    renderTableHeader() {
        return (
            <>
                <tr class="bg-white" id="tableHeader">
                    <td id="lookupHeadingCol1" className="tableHeading">Lookup Type</td>
                    <td id="lookupHeadingCol2" className="tableHeading">Lookup Code</td>
                    <td id="lookupHeadingCol3" className="tableHeading">Meaning</td>
                    <td id="lookupHeadingCol4" className="tableHeading">Active From Date</td>
                    <td id="lookupHeadingCol5" className="tableHeading">Active To Date</td>
                    <td style={{ display: !viewOnly ? "none" : null }}></td>
                </tr>
            </>
        )
    }
    onSearch() {
        this.setState({ filteredIndex: [] }, () => {
            if (this.state.search.length > 0) {
                this.state.maintainLookupData.filter((i, indexcloseds) => {
                    if (i.lookupType.includes(this.state.search) == true || i.lookupType.toLowerCase().includes(this.state.search) == true || i.lookupType.toUpperCase().includes(this.state.search) == true) {
                        console.log('***')
                        let ic = this.state.filteredIndex;
                        ic.push(indexcloseds);
                        this.setState({ filteredIndex: ic }, () => {
                            console.log('inside closed indexfind', this.state.filteredIndex)
                        })
                    }
                    return i.lookupType.includes(this.state.search) || i.lookupType.toLowerCase().includes(this.state.search) || i.lookupType.toUpperCase().includes(this.state.search)
                })
            }
            else {
                console.log('in else no search', this.state.maintainLookupData.map((x, i) => i));
                this.setState({ filteredIndex: this.state.maintainLookupData.map((x, i) => i) }, () => console.log(this.state.filteredIndex))
            }
        })
    }
    handleEditValidation() {
        let errors = {};
        let formIsValid = true;
        this.state.editIndex = this.state.editIndex.filter((element, i) => i === this.state.editIndex.indexOf(element))
        for (let index = 0; index < this.state.editIndex.length; index++) {
            const element = this.state.editIndex[index];
            let fromDate = new Date(Number(this.state.maintainLookupData[element].fromDate));
            let toDate = new Date(Number(this.state.maintainLookupData[element].toDate))
            if (this.state.maintainLookupData[element].toDate != 0 && this.state.isEdit[element]) {
                if (fromDate.getFullYear() > toDate.getFullYear()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }
                if (fromDate.getFullYear() == toDate.getFullYear()) {
                    if (fromDate.getMonth() > toDate.getMonth()) {
                        formIsValid = false;
                        toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                    }
                }
                if (fromDate.getFullYear() == toDate.getFullYear()) {
                    if (fromDate.getMonth() == toDate.getMonth()) {
                        if (fromDate.getDate() > toDate.getDate()) {
                            formIsValid = false;
                            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                        }

                    }
                }
            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    handleValidation() {
        let errors = {};
        let formIsValid = true;
        if (new Date(this.state.fromCalendar).getFullYear() > new Date(this.state.toCalendar).getFullYear()) {
            formIsValid = false;
            toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
        }
        if (new Date(this.state.fromCalendar).getFullYear() == new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() > new Date(this.state.toCalendar).getMonth()) {
                formIsValid = false;
                toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
            }
        }
        if (new Date(this.state.fromCalendar).getFullYear() == new Date(this.state.toCalendar).getFullYear()) {
            if (new Date(this.state.fromCalendar).getMonth() == new Date(this.state.toCalendar).getMonth()) {
                if (new Date(this.state.fromCalendar).getDate() > new Date(this.state.toCalendar).getDate()) {
                    formIsValid = false;
                    toast(message.validation.date, { position: toast.POSITION.TOP_CENTER, style: { color: "red", width: "350px" } })
                }

            }
        }
        this.setState({ errors: errors });
        return formIsValid;
    }
    romoveAddRow = () => {
        this.setState({
            hasAddRow: false,
            lookupType: '',
            lookupCode: '',
            meaning: '',
            fromCalendar: '',
            toCalendar: ''
        })
    }
    render() {
        const renderTableData = this.state.maintainLookupData.map((todo, index) => {
            return (
                this.state.filteredIndex.indexOf(index) != -1 &&
                <>
                    {(!this.state.isEdit[index]) ?
                        <tr key={index} id="maintainLookupdata">
                            <td id="lookupcol1" className="tabledata">{todo.lookupType}</td>
                            <td id="lookupcol2" className="tabledata">{todo.lookupCode}</td>
                            <td id="lookupcol3" className="tabledata">{todo.meaning}</td>
                            <td id="lookupcol4" className="tabledata">{
                                todo.fromDate == 0 ? null :
                                    this.getDate(todo.fromDate)}</td>
                            <td id="lookupcol5" className="tabledata">{
                                todo.toDate == 0 ? null :
                                    this.getDate(todo.toDate)}</td>
                            <td style={{ display: !viewOnly ? "none" : null }}>
                                <div className="editCol">
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/editenable.svg') : require('../../../assets/images/edit.svg')}
                                        width="30" height="30" class="d-inline-block pr-1" alt="" loading="lazy"
                                        class="editimagetablelookup"
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({
                                                isEdit: a,
                                                editIndex: x
                                            });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr> :
                        <tr id="maintainLookupdata">
                            <td id="lookupcol1" className="tabledata">
                                {todo.lookupType}
                            </td>
                            <td id="lookupcol2" className="tabledata">
                                <input
                                    className="maintainLookupInputBox"
                                    autoComplete="off"
                                    value={todo.lookupCode}
                                    onChange={(e) => {
                                        this.state.maintainLookupData[index].lookupCode = e.target.value;
                                        this.setState({ maintainLookupData: this.state.maintainLookupData })
                                    }}
                                ></input>
                            </td>
                            <td id="lookupcol3" className="tabledata">
                                <input
                                    className="maintainLookupInputBox"
                                    autoComplete="off"
                                    value={todo.meaning}
                                    onChange={(e) => {
                                        this.state.maintainLookupData[index].meaning = e.target.value;
                                        this.setState({ maintainLookupData: this.state.maintainLookupData })
                                    }}
                                ></input>
                            </td>
                            <td id="lookupcol4" className="tabledata">
                                <div className="pass-wrapper" id="maintainLookupCalentarDiv" >
                                    <input
                                        readOnly
                                        class="maintainLookupCalendarInputBox"
                                        placeholder="Select Date"
                                        type="text"
                                        value={
                                            todo.fromDate == 0 ? null :
                                                this.getDate(todo.fromDate)}
                                    />
                                    <div
                                    >
                                        <div class="maintainLookupCalendarOutline"
                                        >  {this.state.showEffectiveCalendarArray[index] ? <div ref={this.container}> <Calendar
                                            onChange={(e) => {
                                                this.state.maintainLookupData[index].fromDate = Date.parse(e).toString();
                                                let showEffectiveCalendarArray = this.state.showEffectiveCalendarArray;
                                                showEffectiveCalendarArray[index] = false;
                                                this.setState({ maintainLookupData: this.state.maintainLookupData, showEffectiveCalendarArray: showEffectiveCalendarArray })
                                            }}
                                            minDate={new Date()} /></div> : null}</div>
                                    </div><img id="maintainLookupCalendarImg" src={calendar}
                                        onClick={() => {
                                            let a = this.state.showEffectiveCalendarArray;
                                            console.log(this.state.showEffectiveCalendarArray)
                                            a[index] = true;
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({ showEffectiveCalendarArray: a, editIndex: x }, () => { console.log(this.state.showEffectiveCalendarArray) });
                                        }}
                                    ></img>
                                </div>
                            </td>
                            <td id="lookupcol5" className="tabledata">
                                <div className="pass-wrapper" id="maintainLookupCalentarDiv" >
                                    <input
                                        readOnly
                                        class="maintainLookupCalendarInputBox"
                                        placeholder="Select Date"
                                        type="text"
                                        value={
                                            todo.toDate == 0 ? null :
                                                this.getDate(todo.toDate)}
                                    />
                                    <div>
                                        <div class="maintainLookupCalendarOutline">  {this.state.showExpiryCalendarArray[index] ? <div ref={this.container}> <Calendar
                                            onChange={(e) => {
                                                this.state.maintainLookupData[index].toDate = Date.parse(e).toString();
                                                let showExpiryCalendarArray = this.state.showExpiryCalendarArray;
                                                showExpiryCalendarArray[index] = false;
                                                this.setState({ maintainLookupData: this.state.maintainLookupData, showExpiryCalendarArray: showExpiryCalendarArray })
                                            }}
                                            minDate={new Date(Number(this.state.maintainLookupData[index].fromDate))}
                                        /></div> : null}</div>
                                    </div><img id="maintainLookupCalendarImg" src={calendar}
                                        onClick={() => {
                                            let a = this.state.showExpiryCalendarArray;
                                            a[index] = true;
                                            let x = [...this.state.editIndex];
                                            x.push(index)
                                            this.setState({
                                                showExpiryCalendarArray: a,
                                                editIndex: x
                                            })
                                        }}
                                    ></img>
                                </div>
                            </td>
                            <td>
                                <div className="editCol">
                                    <img
                                        src={(this.state.isEdit[index]) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                        width="30" height="30" class="d-inline-block pr-1" alt="" loading="lazy"
                                        class="editimagetablelookup"
                                        alt=""
                                        onClick={() => {
                                            let a = this.state.isEdit;
                                            a[index] = !this.state.isEdit[index];
                                            this.setState({ isEdit: a });
                                        }}
                                    />
                                </div>
                            </td>
                        </tr>
                    }
                </>
            )
        });
        return (
            <div className="outer1"><div className="outer1" id="outerdiv">
                <MetaDecorator title={TitleDescription.maintainLookupPageTitle} description={TitleDescription.maintainLookupPageDescription} />
                <div className="systemConfigMaintainLookupContainer" >
                    <SideNav />
                    <div id="systemConfigtPart">
                        <h1 id='maintaiLookupHeadingTitle'>Maintain Lookup</h1>
                        {/* View Only Access */}
                        <div className="viewOnlyDiv" style={{ display: !viewOnly ? null : "none" }}>
                            <img alt="View Only Access" src={viewAccess} />
                            <span className="viewOnly">View Only Access</span>
                        </div>
                        <nav class="navbar navbar-light bg-white" id="lookupTypeSearchNav">
                            <div></div>
                            <div>
                                <small id="searchBy">Search by</small>
                                <input
                                    className="lookuptypeSearch"
                                    placeholder="Lookup Type"
                                    autoComplete="off"
                                    id="secrchInputLookupType"
                                    onChange={this.handlechange}
                                    value={this.state.search}
                                ></input>
                                <img id="search_img" src={require('../../../assets/images/search.svg')} width="16" height="16" />
                            </div>
                        </nav>
                        <div className="contentbox">
                            <table id='details'>
                                <tbody>
                                    {this.renderTableHeader()}
                                </tbody>
                            </table>
                            <div id="lookupData">
                                <table id='details'>
                                    <tbody>
                                        {this.state.hasAddRow ? <tr id="maintainLookupdata">
                                            <td id="lookupcol1" className="tabledata">
                                                <input
                                                    className="maintainLookupInputBox"
                                                    autoComplete="off"

                                                    value={this.state.lookupType}
                                                    onChange={this.handlechangeLookupType}
                                                ></input>
                                            </td>
                                            <td id="lookupcol2" className="tabledata">
                                                <input
                                                    className="maintainLookupInputBox"
                                                    autoComplete="off"

                                                    value={this.state.lookupCode}
                                                    onChange={this.handlechangeLookupCode}
                                                ></input>
                                            </td>
                                            <td id="lookupcol3" className="tabledata">
                                                <input
                                                    className="maintainLookupInputBox"
                                                    autoComplete="off"

                                                    value={this.state.meaning}
                                                    onChange={this.handlechangeMeaning}
                                                ></input>
                                            </td>
                                            <td id="lookupcol4" className="tabledata">
                                                <div className="pass-wrapper" id="maintainLookupCalentarDiv" >
                                                    <input
                                                        readOnly
                                                        class="maintainLookupCalendarInputBox"
                                                        placeholder="Select Date"
                                                        type="text"
                                                        value={this.state.fromCalendar}
                                                    />
                                                    <div>
                                                        <div class="maintainLookupCalendarOutline">  {this.state.showFromCalendar ? <div ref={this.container} > <Calendar onChange={this.handleFromDateChanged}
                                                            minDate={new Date()} /></div> : null}</div>
                                                    </div><img id="maintainLookupCalendarImg" src={calendar}
                                                        onClick={this.toggleEffectiveCalendar}
                                                    ></img>
                                                </div>
                                            </td>
                                            <td id="lookupcol5" className="tabledata">
                                                <div className="pass-wrapper" id="maintainLookupCalentarDiv" >
                                                    <input
                                                        readOnly
                                                        class="maintainLookupCalendarInputBox"
                                                        placeholder="Select Date"
                                                        type="text"
                                                        value={this.state.toCalendar}
                                                    />
                                                    <div>
                                                        <div class="maintainLookupCalendarOutline">  {this.state.showToCalendar ? <div ref={this.container}> <Calendar onChange={this.handleToDateChanged} minDate={new Date(this.state.fromCalendar)} /></div> : null}</div>
                                                    </div><img id="maintainLookupCalendarImg" src={calendar} onClick={this.toggleExpiryCalendar}></img>
                                                </div>
                                            </td>
                                            <td>
                                                <div className="editCol">
                                                    <img
                                                        src={(this.state.hasAddRow) ? require('../../../assets/images/cross.svg') : require('../../../assets/images/edit.svg')}
                                                        width="30" height="30" class="d-inline-block pr-1" alt="" loading="lazy"
                                                        class="editimagetablelookup"
                                                        onClick={this.romoveAddRow}
                                                    />
                                                </div>
                                            </td>
                                        </tr>
                                            : null}
                                        {renderTableData}
                                    </tbody>
                                </table>
                            </div>
                            <div className="maintainLookupFooterOuter">
                                <hr width="100%" color="#BCBCBC" />
                                <div id="maintainLookuptableFooter" style={{ display: !viewOnly ? "none" : null }}>
                                    <Link onClick={this.onAddHandleLookup}><img src={this.state.hasAddRow ? addDisable : add} alt="" width="19" height="19" id="maintainlookupaddrole" /> <small className="medlip" style={{ color: this.state.hasAddRow ? "#B6B6B6" : "#428BCA" }}>Add New Lookup</small></Link>
                                    <div class="functionbtndiv">
                                        <button class="confirmfunctionbtn" disabled={this.state.isEdit.includes(true) ? !this.validateEditFormFields() : !this.validateFormFields()} onClick={this.onConfirmMaintainLookup}><small class="confirmfunctionbtntext">Confirm</small></button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <SuccessModal hasOpen={this.state.confirmedHasOpen} onClick={this.onCloseConfirmed}>
                    <p className="confirmedText">Confirmed</p>
                </SuccessModal>
            </div></div>
        )
    }
}
function mapStateToProps(state) {
    return { data: state.adminRoleReducer.roleData }
}
export default connect(mapStateToProps)(MaintainLookup);